// Styles
import styles from './Tool.module.css';
// Libraries
import React from 'react';
import { useDrag } from 'react-dnd';
import { TEMPLATE_TYPES } from '../../constants/templateTypes';
import { FORM_TYPES } from '../../constants/formTypes';
import {
  ShortText,
  CheckBox,
  ArrowDropDownCircleRounded,
  RadioButtonChecked,
  LinearScaleRounded,
  TextFields,
  Email,
  DateRange,
  Notes,
  Description,
  Home,
  Edit,
  UploadFile
} from '@mui/icons-material';
import { useAutoTranslation } from 'src/hooks/useTranslate';

const TOOL_META = {
  [FORM_TYPES.SHORT_TEXT]: { Icon: ShortText, color: '#2ba9bf' },
  [FORM_TYPES.LONG_TEXT]: { Icon: Notes, color: '#2ba9bf' },
  [FORM_TYPES.EMAIL_INPUT]: { Icon: Email, color: '#2ba9bf' },
  [FORM_TYPES.DATE_TIME_INPUT]: { Icon: DateRange, color: '#2ba9bf' },
  [FORM_TYPES.CHECKBOX_INPUT]: { Icon: CheckBox, color: '#e0a400' },
  [FORM_TYPES.DROPDOWN]: { Icon: ArrowDropDownCircleRounded, color: '#e0a400' },
  [FORM_TYPES.MULTIPLE_CHOICE]: { Icon: RadioButtonChecked, color: '#e0a400' },
  [FORM_TYPES.LINEAR_SCALE]: { Icon: LinearScaleRounded, color: '#e0a400' },
  [FORM_TYPES.FILE_UPLOAD]: { Icon: UploadFile, color: '#5b6b7f' },
  [FORM_TYPES.SIGNATURE]: { Icon: Edit, color: '#5b6b7f' },
  [FORM_TYPES.EMBED_CONTENT]: { Icon: TextFields, color: '#5b6b7f' },
  [TEMPLATE_TYPES.DEMOGRAPHICS]: { Icon: Description, color: '#d6336c' },
  [TEMPLATE_TYPES.ADDRESS]: { Icon: Home, color: '#d6336c' }
};

function Tool({ toolName, tool, type }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'tool',
    item: { toolName: `${toolName}` },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  }));

  const t = useAutoTranslation();

  const { Icon, color } = TOOL_META[tool.key] || {
    Icon: TextFields,
    color: '#5b6b7f'
  };

  return (
    <div
      ref={drag}
      className={`${styles.Tool} ${
        type === 'template' ? styles.TemplateTool : ''
      }`}
      style={{ opacity: isDragging ? 0.4 : 1 }}
      title={`${t(toolName)} — ${t('drag onto a section')}`}
    >
      <span
        className={styles.IconWrap}
        style={{ backgroundColor: `${color}1A`, color }}
      >
        <Icon fontSize="small" />
      </span>
      <span className={styles.ToolLabel}>{t(toolName)}</span>
    </div>
  );
}

export default Tool;
